/**
 * Filter token for server-side enrollment-type filters (not a DB storage value).
 * Must match improve-api `ADMIN_ASSIGNED_ENROLLMENT_FILTER`.
 */
export const ADMIN_ASSIGNED_ENROLLMENT_FILTER = "admin-assigned" as const;

/** Enrollment type filter values shown in admin grid single-select filters. */
export const ENROLLMENT_TYPE_FILTER_VALUES = [
	"learner",
	"auto-assign-schedule",
	ADMIN_ASSIGNED_ENROLLMENT_FILTER
] as const;
